var helperGetDateTime = require('./helperGetDateTime')
var helperNewDate = require('./helperNewDate')

/**
 * 返回当前时间戳
 *
 * @returns Number
 */
var now = Date.now || function () {
  return helperGetDateTime(helperNewDate())
}

module.exports = now



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/now.js
// module id = 456
// module chunks = 75